export const AFAXYS_TERMS_OF_USE_HREF =
  "https://afaxyspharma.com/terms-of-use/"
export const AFAXYS_PRIVACY_POLICY_HREF =
  "https://afaxys.com/privacy-policy/"
export const AFAXYS_NOTICE_OF_FINANCIAL_INCENTIVE_HREF =
  "https://www.afaxys.com/privacy-policy/#notice-of-financial-incentive"
export const AFAXYS_COUPON_TERMS_HREF =
  "https://www.afaxys.com/product-purchase-agreement-terms-and-conditions/"
export const AFAXYS_SIGNUP_PRIVACY_POLICY_HREF =
  "https://www.afaxys.com/privacy-policy/"
export const AFAXYS_HEALTH_DATA_POLICY_HREF =
  "https://www.afaxys.com/health-data-privacy-policy/"
export const AFAXYS_SIGNUP_TERMS_OF_USE_HREF =
  "https://www.afaxys.com/terms-of-use/"
